<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">查看店铺</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="店铺号:">
          <span>{{ basicInfo.storeCode }}</span>
        </el-form-item>
        <el-form-item label="店铺名称:"> {{ basicInfo.storeName }} </el-form-item>
        <el-form-item label="客户姓名:"> {{ basicInfo.createdName }} </el-form-item>
        <el-form-item label="手机号:"> {{ basicInfo.phone }} </el-form-item>
        <el-form-item label="问题类型:"> {{ basicInfo.firstProblemType }} - {{ basicInfo.secondProblemType }} </el-form-item>
        <el-form-item label="问题描述:"> {{ basicInfo.problemDescription }} </el-form-item>
        <el-form-item label="图片:">
          <div style="display: flex;">
            <div v-for="(image, index) in basicInfo.fileList" :key="image.id" class="image-item">
              <el-image :src="image.content" :preview-src-list="basicInfo.fileList.map((item) => item.content)" :initial-index="index" :alt="`图片${image.id}`" fit="cover" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="追加:">
          <div class="description-section" v-for="(append, index) in basicInfo.leaveMessageList" :key="index">
            <div style="flex: 1; display: flex; flex-direction: column">
              <div style="font-size: 16px; flex: 1; margin-bottom: 10px"> {{ append[0].content || '暂无描述' }} </div>
              <div class="images-grid">
                <div v-for="(image, index2) in append.slice(1)" :key="image.id" class="image-item">
                  <el-image :src="image.content" :preview-src-list="append.map((item) => item.content)" :initial-index="index2" :alt="`图片${image.id}`" fit="cover" />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="回复:"> {{ basicInfo.replyContent }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { videoSeasonFeedbackInfo } from '@/api/pms'
export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      statusList: [{
        value: 0,
        label: '非会员'
      }, {
        value: 1,
        label: '会员'
      },
      {
        value: 2,
        label: '过期会员'
      },
      {
        value: 3,
        label: '即将过期会员'
      }
      ],
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        fileList: []
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    let id = this.$route.query.id
    videoSeasonFeedbackInfo(id).then((res) => {
      if (res.data.success) {
        this.basicInfo = res.data.data
        this.basicInfo.phone = this.$msg.filterBridal(res.data.data.phone)
      }
    })
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

.image-item {
  width: 150px;
  margin-right: 10px;
}

.description-section {
  width: 468px;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;

  .images-grid {
    display: grid;
    grid-template-columns: repeat(3, 70px);
    gap: 10px;

    .image-item {
      width: 70px;
      height: 70px;
      overflow: hidden;
      cursor: pointer;
    }
  }

  .section-title {
    width: 80px;
    text-align: right;
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    // margin-bottom: 12px;
  }

  &:not(:last-child) {
    // margin-bottom: 12px;
  }
}
</style>
